import { BoostProviderManager } from "../Provider/Provider";
import { OnClickABoostProvider } from "./boost/OnClickABoostProvider";
import { TappAdsBoostProvider } from "./boost/TappAdsBoostProvider";
import { AdsgramBoostProvider } from "./boost/AdsgramBoostProvider";
import { barzaBoostProvider } from "./boost/BarzaBoostProvider";
import { tadsBoostProvider } from "./boost/TadsBoostProvider";
import { AdextraBoostProvider } from "./boost/AdextraBoostProvider";
import { RichAdsBoostProvider } from "./boost/RichAdsBoostProvider";
import { dreamCoinBoostProvider } from "./boost/DreamCoinBoostProvider";
import { RandomizedAdProvider } from "./boost/RandomizedAdProvider";
import { BoostTask } from "../types/boost";
import { MonetagBoostProvider } from "./boost/MonetagBoostProvider";
import { AdexiumBoostProvider } from "./boost/AdexiumBoostProvider";

export class BoostMiningService {
  static initialize() {
    BoostProviderManager.registerProvider(dreamCoinBoostProvider, 8);
    BoostProviderManager.registerProvider(barzaBoostProvider, 7);
    BoostProviderManager.registerProvider(tadsBoostProvider, 6);
    BoostProviderManager.registerProvider(new RichAdsBoostProvider(), 5);
    // BoostProviderManager.registerProvider(new TappAdsBoostProvider(), 4);
    BoostProviderManager.registerProvider(new AdexiumBoostProvider(), 4);
    BoostProviderManager.registerProvider(new MonetagBoostProvider(), 3);
    BoostProviderManager.registerProvider(new RandomizedAdProvider(), 2);
    // // // BoostProviderManager.registerProvider(new AdextraBoostProvider(), 2);
    // // // BoostProviderManager.registerProvider(new OnClickABoostProvider(), 1);
    BoostProviderManager.registerProvider(new AdsgramBoostProvider(), 1);
  }

  static async getAllAvailableTasks(miningId: number): Promise<BoostTask[]> {
    console.log("BoostMiningService: Getting all available tasks...");
    const allTasks: BoostTask[] = [];
    const providers = BoostProviderManager.getProviders();
    const processedProviders = new Set<string>();

    for (const provider of providers) {
      const providerName = provider.getName();
      if (processedProviders.has(providerName)) {
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks(miningId);
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found: ${allTasks.length}`
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpm(
    miningId: number
  ): Promise<BoostTask[]> {
    console.log("BoostMiningService: Getting all available tasks (no CPM)...");
    const allTasks: BoostTask[] = [];
    const providers = BoostProviderManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = ["DreamCoin", "Barza", "Tads", "RichAds_CPC"];

    for (const provider of providers) {
      const providerName = provider.getName();

      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPM)`
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks(miningId);
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPM): ${allTasks.length}`
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoAdexium(
    miningId: number
  ): Promise<BoostTask[]> {
    console.log(
      "BoostMiningService: Getting all available tasks (no Adexium)..."
    );
    const allTasks: BoostTask[] = [];
    const providers = BoostProviderManager.getProviders();
    const processedProviders = new Set<string>();

    for (const provider of providers) {
      const providerName = provider.getName();
      console.log(providerName);

      // Пропускаем Adexium провайдер
      if (providerName === "adexium") {
        console.log("Пропускаем Adexium провайдер");
        continue;
      }

      if (processedProviders.has(providerName)) {
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks(miningId);
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no Adexium): ${allTasks.length}`
    );
    return allTasks;
  }

  static async getSpecificTasks(
    miningId: number,
    mode: "noTads" | string[]
  ): Promise<BoostTask[]> {
    console.log("BoostMiningService: Getting tasks with mode:", mode);
    const allTasks: BoostTask[] = [];
    const providers = BoostProviderManager.getProviders();
    const processedProviders = new Set<string>();

    for (const provider of providers) {
      const providerName = provider.getName();

      // Пропускаем TadsBoostProvider если mode === "noTads"
      if (mode === "noTads" && providerName === "Tads") {
        console.log("Пропускаем TadsBoostProvider");
        continue;
      }

      if (processedProviders.has(providerName)) {
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks(miningId);
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(`BoostMiningService: Total tasks found: ${allTasks.length}`);
    return allTasks;
  }

  static resetBoostState() {
    console.log("Resetting boost state (clearing provider errors)");
    BoostProviderManager.getProviders().forEach((provider) => {
      if (typeof provider.resetError === "function") {
        provider.resetError();
      }
    });
  }
}

// Инициализируем провайдеры при импорте сервиса
BoostMiningService.initialize();
